export const tpl = '<table class="tip-content-table" style="width:100%" cellpadding="0" cellspacing="0">' +
    '<tr>' +
        '<th>展位编号:</th><td>{code}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>展位名称:</th><td>{fullname}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>展位类型:</th><td>{boothType}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>出口类型:</th><td>{entryType}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>横向长度:</th><td>{lateralLength}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>纵向长度:</th><td>{verticalLength}</td>' +
    '</tr>' +
    '<tr>' +
        '<th>展位面积:</th><td>{area}</td>' +
    '</tr>' +
'</table>'



// WEBPACK FOOTER //
// ./src/components/ploter/businessShape/tipTpl.js